import { useQuery } from "@tanstack/react-query";

import useFetch from "../lib/useFetch";
import {
  IPlatformUsageFee,
  IPlatformUsageFeeFilters,
} from "../types/platformUsageFee";

const API = process.env.REACT_APP_API;

const usePlatformUsageFees = (filters: IPlatformUsageFeeFilters) => {
  const fetch = useFetch();
  const search = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      search.set(key, value);
    }
  });

  return useQuery<IPlatformUsageFee[]>({
    queryKey: ["platform-usage-fees", filters],
    queryFn: () =>
      fetch(`${API}/api/semeadora/reports/platform-usage-fees/?${search}`),
  });
};

export default usePlatformUsageFees;
